import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: __dirname,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/',
    component: resolve => require(['../components/index/index.vue'], resolve),//首页,
    alias: '/index',
    children: [
      {
        path: '/',
        component: resolve => require(['../views/basicInfo/prMoDrInMa.vue'], resolve),
      }, {
        path: '/Blacklist',//黑名单
        component: resolve => require(['../views/Blacklist/Blacklist.vue'], resolve),
      }, {
        path: '/testPage',
        component: resolve => require(['../views/demo/testPage.vue'], resolve),
      }, {
        path: '/allorgmsg',
        component: resolve => require(['../views/statisticAnalysis/orgName/allorgmsg.vue'], resolve),
      }, {
        path: '/fileUpload',
        component: resolve => require(['../views/basicInfo/fileUpload.vue'], resolve),
      }, {
        path: '/myself',//账户激活
        component: resolve => require(['../views/mymes/myself.vue'], resolve),
      }, {
        path: '/orgmsgAffirm',//机构账户激活
        component: resolve => require(['../views/mymes/orgmsgAffirm.vue'], resolve),
      },
      {
        path: '/businesPassword',//机构账户激活
        component: resolve => require(['../views/mymes/businesPassword.vue'], resolve),
      },
      {
        path: '/cycleReport',// 周期性监测报告
        component: resolve => require(['../views/drugIsSllowed/cycleReport.vue'], resolve),
      },
      {
        path: '/burstReportList',// 突发性监测报告列表
        component: resolve => require(['../views/drugIsSllowed/burstReportList.vue'], resolve),
      },
      {
        path: '/addBurstReport',// 突发性监测报告添加
        component: resolve => require(['../views/drugIsSllowed/addBurstReport.vue'], resolve),
      },
      {
        path: '/emphasisDrug',//重点药品填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrug.vue'], resolve),
      }, {
        path: '/emphasisDrugJC',//集采药品清单填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugJC.vue'], resolve),
      }, {
        path: '/emphasisDrug_Form',//重点药品表单填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrug_Form.vue'], resolve),
      }, {
        path: '/emphasisDrugHei_Form',//重点药品表单填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugHei_Form.vue'], resolve),
      },{
        path: '/emphasisDrug_Liutong',//重点药品表单填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrug_Liutong.vue'], resolve),
      },  {
        path: '/emphasisDrugJC_Form',//集采重点药品表单填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugJC_Form.vue'], resolve),
      }, {
        path: '/emphasisDrug_Card',//重点药品卡片填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrug_Card.vue'], resolve),
      }, {
        path: '/emphasisDrugJC_Card',//集采重点药品卡片填报
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugJC_Card.vue'], resolve),
      }, {
        path: '/allot',//设置调拨数量页
        name: 'allot',
        component: resolve => require(['../views/drugIsSllowed/allot.vue'], resolve),
      }, {
        path: '/emphasisDrug_look',//重点药品查看
        name: 'emphasisDrug_look',
        component: resolve => require(['../views/drugIsSllowed/emphasisDrug_look.vue'], resolve),
      },{
        path: '/emphasisDrugJC_look',//集采重点药品查看
        name: 'emphasisDrugJC_look',
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugJC_look.vue'], resolve),
      },{
        path: '/emphasisDrugHei_look',//集采重点药品查看
        name: 'emphasisDrugHei_look',
        component: resolve => require(['../views/drugIsSllowed/emphasisDrugHei_look.vue'], resolve),
      },{
        path: '/goLookPage_look',//非重点药品查看
        component: resolve => require(['../views/drugIsSllowed/goLookPage_look.vue'], resolve),
      }, {
        path: '/moniToring',//黑龙江查看表单
        component: resolve => require(['../views/drugIsSllowed/moniToring'], resolve),
      },
      {
        path: '/drugShortageInfor',//黑龙江查看表单
        component: resolve => require(['../views/drugIsSllowed/drugShortageInfor'], resolve),
      },
      {
        path: '/moniTrings',//黑龙江查看表单
        component: resolve => require(['../views/drugIsSllowed/moniTrings'], resolve),

      },
      {
        path: '/Institutionsprovided',//机构填报管理
        component: resolve => require(['../views/Institutions/Institutionsprovided.vue'], resolve),
      },
      { 
        path: '/Revocationlist',//机构撤销列表
        component: resolve => require(['../views/Institutions/Revocationlist.vue'], resolve),
      },
      {
        path: '/nonKeyDrug',//非重点药品填报
        component: resolve => require(['../views/drugIsSllowed/nonKeyDrug.vue'], resolve),
      }, {
        path: '/nonKeyDrugAdd',//非重点药品填报-添加
        component: resolve => require(['../views/drugIsSllowed/nonKeyDrugAdd.vue'], resolve),
      }, {
        path: '/disposeInfo',//上报短缺药品处置情况
        component: resolve => require(['../views/disposeQuery/disposeInfo.vue'], resolve),
      }, {
        path: '/liutongHandle',//上报短缺药品处置情况
        component: resolve => require(['../views/disposeQuery/liutongHandle.vue'], resolve),
      }, {
        path: '/pandectCouBox',//短缺药品上报情况（县级）
        name: 'pandectCouBox',
        component: resolve => require(['../views/statisticAnalysis/drugBox/pandectCouBox.vue'], resolve),
      }, {
        path: '/pandectCitBox',//短缺药品上报情况（市级）
        component: resolve => require(['../views/statisticAnalysis/drugBox/pandectCitBox.vue'], resolve),
      }, {
        path: '/pandectProBox',//短缺药品上报情况（省级）
        component: resolve => require(['../views/statisticAnalysis/drugBox/pandectProBox.vue'], resolve),
      }, {
        path: '/peisongJigou',//短缺药品上报情况（省级）
        component: resolve => require(['../views/statisticAnalysis/drugBox/peisongJigou.vue'], resolve),
      },{
        path: '/provPeisongLook',// 短缺药品上报情况-云南省
        component: resolve => require(['../views/statisticAnalysis/drugBox/provPeisongLook.vue'], resolve),
      },{
        path: '/pandectStateBox',//短缺药品上报情况（国家）
        component: resolve => require(['../views/statisticAnalysis/drugBox/pandectStateBox.vue'], resolve),
      },{
        path: '/guigeDetail',//短缺药品规格查看
        component: resolve => require(['../views/statisticAnalysis/drugBox/guigeDetail.vue'], resolve),
      }, {
        path: '/couDetail',//上报信息查看
        name: 'couDetail',
        component: resolve => require(['../views/statisticAnalysis/drugBox/couDetail.vue'], resolve),
      },{
        path: '/peisongDetail',//上报信息查看
        name: 'peisongDetail',
        component: resolve => require(['../views/statisticAnalysis/drugBox/peisongDetail.vue'], resolve),
      }, {
        path: '/JCcouDetail',//集采上报信息查看
        name: 'JCcouDetail',
        component: resolve => require(['../views/statisticAnalysis/drugBox/JCcouDetail.vue'], resolve),
      }, {
        path: '/invStati',//清单内短缺药品库存统计
        component: resolve => require(['../views/statisticAnalysis/invStati.vue'], resolve),
      }, {
        path: '/occurCount',//已上报短缺药品查询
        component: resolve => require(['../views/statisticAnalysis/occurCount.vue'], resolve),
      }, {
        path: '/occurCountXq',//清单外
        component: resolve => require(['../views/statisticAnalysis/occurCountXq.vue'], resolve),
      }, {
        path: '/occurCountXQS',//清单内
        component: resolve => require(['../views/statisticAnalysis/occurCountXQS.vue'], resolve),
      },
      {
        path: '/occurCountHei',//清单内
        component: resolve => require(['../views/statisticAnalysis/occurCountHei.vue'], resolve),
      },
      {
        path: '/occurCountZhouqi',//周期性详情
        component: resolve => require(['../views/statisticAnalysis/occurCountZhouqi.vue'], resolve),
      },
      {
        path: '/occurCountTufa',//突发性详情
        component: resolve => require(['../views/statisticAnalysis/occurCountTufa.vue'], resolve),
      },
       {
        path: '/invStatiCou',//清单内短缺药品库存统计（县级）
        component: resolve => require(['../views/statisticAnalysis/invStatiBox/invStatiCou.vue'], resolve),
      }, {
        path: '/invStatiCit',//清单内短缺药品库存统计（市级）
        component: resolve => require(['../views/statisticAnalysis/invStatiBox/invStatiCit.vue'], resolve),
      }, {
        path: '/invStatiPro',//清单内短缺药品库存统计（省级）
        component: resolve => require(['../views/statisticAnalysis/invStatiBox/invStatiPro.vue'], resolve),
      }, {
        path: '/invStatiState',//清单内短缺药品库存统计（国家）
        component: resolve => require(['../views/statisticAnalysis/invStatiBox/invStatiState.vue'], resolve),
      }, {
        path: '/allorgmsg',//区域内管理机构名单
        component: resolve => require(['../views/statisticAnalysis/orgName/allorgmsg.vue'], resolve),
      }, {
        path: '/analyze',//分享分析
        component: resolve => require(['../views/statisticAnalysis/analyze.vue'], resolve),
      }, {
        path: '/analyzeInfo',//分享分析详情
        component: resolve => require(['../views/statisticAnalysis/analyzeInfo.vue'], resolve),
      }, {
        path: '/priceMonitoring',//药品价格检测
        component: resolve => require(['../views/confirmationShortage/priceMonitoring.vue'], resolve),
      }, {
        path: '/priceMonitoringInfo',//药品价格检测
        component: resolve => require(['../views/confirmationShortage/priceMonitoringInfo.vue'], resolve),
      }, {
        path: '/drugShortageNotarizeHome',//已短缺药品信息确认总览
        component: resolve => require(['../views/confirmationShortage/drugShortageNotarizeHome.vue'], resolve),
      }, {
        path: '/drugShortageNotarize',//已短缺药品信息确认
        component: resolve => require(['../views/confirmationShortage/drugShortageNotarize.vue'], resolve),
      },{
        path: '/handle',//处置页面
        component: resolve => require(['../views/confirmationShortage/handle.vue'], resolve),
      },{
        path: '/liuTongHandel',//处置页面
        component: resolve => require(['../views/confirmationShortage/liuTongHandel.vue'], resolve),
      }, {
        path: '/importReport',//医疗机构导入上报
        component: resolve => require(['../views/basicInfo/importReport.vue'], resolve),
      }, {
        path: '/keyMoDrListMa',//重点监测药品清单管理
        component: resolve => require(['../views/basicInfo/keyMoDrListMa.vue'], resolve),
        children: [
          {
            path: 'provQdSearch',//省级清单查询列表
            name: 'provQdSearch',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/provQdSearch.vue'], resolve)
          },
          {
            path: 'provQdInfo',//省级清单查询详情
            name: 'provQdInfo',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/provQdInfo.vue'], resolve)
          },
          {
            path: 'keyMoAll',//国家级重点监测药品清单
            name: 'keyMoAll',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/keyMoAll.vue'], resolve)
          },
          {
            path: 'editList',//国家级重点监测药品清单的修改列表
            name: 'editList',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/editList.vue'], resolve)
          },
          {
            path: 'add',//新增药品清单
            name: 'add',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/add.vue'], resolve)
          },
          {
            path: 'edit',//编辑药品清单
            name: 'edit',
            component: resolve => require(['../views/basicInfo/keyMoDrListMa/edit.vue'], resolve)
          }
        ]
      }, {
        path: '/maBaInMa',//管理部门基本信息管理
        component: resolve => require(['../views/basicInfo/maBaInMa.vue'], resolve),
      }, {
        path: '/maBaInMaAdd',//管理部门基本信息新增
        component: resolve => require(['../views/basicInfo/maBaInMaAdd.vue'], resolve),
      }, 
      {
        path: '/maBaInMaCityCou',//管理部门基本信息管理--定制化 市和县级
        component: resolve => require(['../views/basicInfo/maBaInMa_city_cou.vue'], resolve),
      },
      {
        path: '/deriveFiles',//运维端导出组合，运维使用
        component: resolve => require(['../views/basicInfo/deriveFiles.vue'], resolve),
      },
      {
        path: '/prMoDrInMa',//本省监测药品清单管理
        component: resolve => require(['../views/basicInfo/prMoDrInMa.vue'], resolve),
        children: [
          {
            path: 'prMoAll',//省级重点监测药品清单
            name: 'prMoAll',
            component: resolve => require(['../views/basicInfo/prMoDrInMa/prMoAll.vue'], resolve),
          },
          {
            path: 'prMoAllJC',//省级集采药品清单
            name: 'prMoAllJC',
            component: resolve => require(['../views/basicInfo/prMoDrInMa/prMoAllJC.vue'], resolve),
          },
          {
            path: 'prEditList',//省级重点监测药品清单的修改列表
            name: 'prEditList',
            component: resolve => require(['../views/basicInfo/prMoDrInMa/prEditList.vue'], resolve),

          },
          {
            path: 'prAdd',//新增药品清单
            name: 'prAdd',
            component: resolve => require(['../views/basicInfo/prMoDrInMa/prAdd.vue'], resolve),

          },
          {
            path: 'prEdit',//编辑药品清单
            name: 'prEdit',
            component: resolve => require(['../views/basicInfo/prMoDrInMa/prEdit.vue'], resolve),

          }
        ]
      }, {
        path: '/releaseNewsList',//已解决药品信息发布
        component: resolve => require(['../views/news/releaseNewsList.vue'], resolve),
      }, {
        path: '/releaseNews',//发送消息新增页
        component: resolve => require(['../views/news/releaseNews.vue'], resolve),
      },{
        path: '/releaseNewsListFWB',//监测报告列表带富文本
        component: resolve => require(['../views/news/releaseNewsListFWB.vue'], resolve),
      }, {
        path: '/releaseNewsFWB',//监测报告新增页带富文本
        component: resolve => require(['../views/news/releaseNewsFWB.vue'], resolve),
      },{
        path: '/releaseNewsListFWB2',//药品信息列表带富文本
        component: resolve => require(['../views/news/releaseNewsListFWB2.vue'], resolve),
      }, {
        path: '/releaseNewsFWB2',//药品信息新增页带富文本
        component: resolve => require(['../views/news/releaseNewsFWB2.vue'], resolve),
      }, {
        path: '/resolvedList',//已解决药品信息发布
        component: resolve => require(['../views/news/resolvedList.vue'], resolve),
      }, {
        path: '/resolvedSee',//新增已解决药品信息发布详情
        component: resolve => require(['../views/news/resolvedSee.vue'], resolve),
      }, {
        path: '/resolvedNews',//已解决药品信息发布详情
        component: resolve => require(['../views/news/resolvedNews.vue'], resolve),
      }, {
        path: '/collectNewsList',//接受消息列表页
        component: resolve => require(['../views/news/collectNewsList.vue'], resolve),
      }, {
        path: '/collectNews',//接受消息详情页
        component: resolve => require(['../views/news/collectNews.vue'], resolve),
      },{
        path: '/collectNewsListYPXX',//药品信息列表页
        component: resolve => require(['../views/news/collectNewsListYPXX.vue'], resolve),
      }, {
        path: '/collectNewsYPXX',//药品信息详情页
        component: resolve => require(['../views/news/collectNewsYPXX.vue'], resolve),
      },{
        path: '/collectNewsListJCBG',//监测报告列表页
        component: resolve => require(['../views/news/collectNewsListJCBG.vue'], resolve),
      }, {
        path: '/collectNewsJCBG',//监测报告详情页
        component: resolve => require(['../views/news/collectNewsJCBG.vue'], resolve),
      }, {
        path: '/ywreleaseNewsList',//4+7---已解决药品信息发布
        component: resolve => require(['../views/news/ywreleaseNewsList.vue'], resolve),
      }, {
        path: '/ywreleaseNews',//4+7---发送消息新增页
        component: resolve => require(['../views/news/ywreleaseNews.vue'], resolve),
      }, {
        path: '/ywcollectNewsList',//4+7---接受消息列表页
        component: resolve => require(['../views/news/ywcollectNewsList.vue'], resolve),
      }, {
        path: '/ywcollectNews',//4+7---接受消息详情页
        component: resolve => require(['../views/news/ywcollectNews.vue'], resolve),
      }, {
        path: '/baInMaMeIn',//医疗机构基本信息管理
        component: resolve => require(['../views/basicInfo/baInMaMeIn.vue'], resolve),
      }, {
        path: '/baInMaMeInAdd',//医疗机构基本信息新增
        component: resolve => require(['../views/basicInfo/baInMaMeInAdd.vue'], resolve),
      },{
        path: '/baInMaMeInCityCou',//医疗机构基本信息管理-定制市和县级
        component: resolve => require(['../views/basicInfo/baInMaMeIn_city_cou.vue'], resolve),
      },
       {
        path: '/liutongMaMeIn',//流通企业基本信息管理
        component: resolve => require(['../views/basicInfo/liutongMaMeIn.vue'], resolve),
      }, {
        path: '/liutongMaMeInAdd',//流通企业基本信息新增
        component: resolve => require(['../views/basicInfo/liutongMaMeInAdd.vue'], resolve),
      }, {
        path: '/drDaDiMa',//药品数据字典管理
        component: resolve => require(['../views/basicInfo/drDaDiMa.vue'], resolve),
      }, {
        path: '/drDaDiMaAdd',//药品数据字典管理
        component: resolve => require(['../views/basicInfo/drDaDiMaAdd.vue'], resolve),
      }, {
        path: '/prCiEnDiMa',//生产流通企业字典管理
        component: resolve => require(['../views/basicInfo/prCiEnDiMa.vue'], resolve),
      }, {
        path: '/prCiEnDiMaAdd',//生产流通企业字典管理新增
        component: resolve => require(['../views/basicInfo/prCiEnDiMaAdd.vue'], resolve),
      }, {
        path: '/mapPandect',//国家药品短缺状态图
        component: resolve => require(['../views/pandect/mapPandect.vue'], resolve),
      }, {
        path: '/drugTop',//机构上报药品排名统计
        component: resolve => require(['../views/pandect/drugTop.vue'], resolve),
      }, {
        path: '/shortageTop',//短缺数量排名统计
        component: resolve => require(['../views/pandect/shortageTop.vue'], resolve),
      }, {
        path: '/allHandle',//处置情况统计
        component: resolve => require(['../views/pandect/allHandle.vue'], resolve),
      }, {
        path: '/specialAddAll',//单药品专项统计
        component: resolve => require(['../views/pandect/specialAddAll.vue'], resolve),
      }, {
        path: '/drugSortStatistics',//单药品专项统计
        component: resolve => require(['../views/pandect/drugSortStatistics.vue'], resolve),
      }, {
        path: '/jumpPage',//自定义页面 
        component: resolve => require(['../views/pandect/jumpPage.vue'], resolve),
      }, {
        path: '/disposeOfInfo',//代处置详情 
        component: resolve => require(['../views/disposeOf/disposeOfInfo.vue'], resolve),
      }, {
        path: '/disposeOf',//代处置
        component: resolve => require(['../views/disposeOf/disposeOf.vue'], resolve),
      }, {
        path: '/singleOfInfo',//机构代处置详情 
        component: resolve => require(['../views/disposeOf/single/singleOfInfo.vue'], resolve),
      }, {
        path: '/singleOf',//机构代处置
        component: resolve => require(['../views/disposeOf/single/singleOf.vue'], resolve),
      },
      //下面为新增药企响应系统路由
      {
        path: '/ncovProdPage',//此页面是《省级药企单位响应端》新加的页面
        name:"呼吸系统疾病治疗药物周报专区",
        component: resolve => require(['../views/drugFirm/ncovProdPage.vue'], resolve),
      },
      {
        path: '/shortageQuery',
        name:"药品短缺情况查询",
        component: resolve => require(['../views/drugFirm/shortageQuery.vue'], resolve),
      },
      {
        path: '/responsePage',
        name:"已响应短缺药品",
        component: resolve => require(['../views/drugFirm/responsePage.vue'], resolve),
      },
      {
        path: '/firmReportAdmin',
        name:"上报短缺药品",
        component: resolve => require(['../views/drugFirm/firmReportAdmin.vue'], resolve),
      },
      {
        path: '/firmReportAdd',
        name:"填报短缺药品",
        component: resolve => require(['../views/drugFirm/firmReportAdd.vue'], resolve),
      },
      {
        path: '/responseStatus',//此页面是《填报端》新加的页面
        name:"短缺药品药企响应情况",
        component: resolve => require(['../views/drugFirm/responseStatus.vue'], resolve),
      },
      {
        path: '/reportStatusAdmin',//此页面是《省级主管部门管理端》新加的页面
        name:"短缺药品药企上报情况",
        component: resolve => require(['../views/drugFirm/reportStatusAdmin.vue'], resolve),
      },
      {
        path: '/ncovPage',//此页面是《医疗机构 山东省》新加的页面
        name:"山东省新冠治疗重点关注药品",
        component: resolve => require(['../views/drugFirm/ncovPage.vue'], resolve),
      },

      {
        path: '/videoListAd',//视频列表
        name:"山东省新冠治疗重点关注药品",
        component: resolve => require(['../views/videoList/videoListAd.vue'], resolve),
      },
    ]
  }, {
    path: '/login',
    component: resolve => require(['../views/user/login.vue'], resolve)
  }, {
    path: '/loginlist',
    component: resolve => require(['../views/user/loginlist.vue'], resolve)
  }, {
    path: '/register',
    component: resolve => require(['../views/user/register.vue'], resolve)
  },
  {
    path: '/loginDrugFirm',//新功能 药品企业登录
    component: resolve => require(['../views/user/loginDrugFirm.vue'], resolve)
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js